<template>

    <v-row style="overflow-y:auto; max-width: 600px; margin: 0 auto; max-height: 60px" class="px-0 mx-auto" >
      <v-col id="foot"  class="my-0 py-0" >
        <v-row class="py-0 my-0" justify="center" align="center" style="background-color: #E6E6E6;">
          <v-spacer></v-spacer>
          <v-col cols="auto" style="background-color: #E6E6E6; color: #403F3F; font-size: 14px; padding-top: 11px" class="RestoRegular mx-0 px-0" justify="center" align="center">
              Cantidad:
          </v-col>
          <v-col v-if="$store.state.maxContValidation == 0" cols="auto" style="background-color: #E6E6E6;" justify="center" align="center" class="mx-0 px-0">
            <div style="overflow: hidden; "><v-btn :disabled="counter_footer <= 1 || $store.state.maxContValidation == 0" @click="$store.state.counter_footerMUC0--" class="btn-left" icon large color="grey" style="padding-left: 0px; width:29px; height:29px; margin-left: 5px; margin-right: 5px;"><img class='icon' src="@/assets/resources/icons/icon_value_less.png" style="width:29px; height:29px;"></v-btn><span style="text-align: center;" class="RestoRegular">{{ $store.state.counter_footerMUC0 }}</span><v-btn :disabled="$store.state.maxContValidation == 0" class="btn-right" @click="$store.state.counter_footerMUC0++; TheAlert();" icon large color="grey" style="width:29px; height:29px; margin-left: 5px; margin-right: 5px;"><img class='icon' src="@/assets/resources/icons/icon_value_more.png" style="width:29px; height:29px;"></v-btn></div>
          </v-col>

          <v-col v-else cols="auto" style="background-color: #E6E6E6;" justify="center" align="center" class="mx-0 px-0">
            <div style="overflow: hidden; "><v-btn :disabled="counter_footer <= 1" @click="counter_footer--" class="btn-left" icon large color="grey" style="padding-left: 0px; width:29px; height:29px; margin-left: 5px; margin-right: 5px;"><img class='icon' src="@/assets/resources/icons/icon_value_less.png" style="width:29px; height:29px;"></v-btn><span style="text-align: center;" class="RestoRegular">{{ counter_footer }}</span><v-btn @click="counter_footer++; TheAlert();" icon large color="grey" style="width:29px; height:29px; margin-left: 5px; margin-right: 5px;"><img class='icon' src="@/assets/resources/icons/icon_value_more.png" style="width:29px; height:29px;"></v-btn></div>
          </v-col>

          <v-spacer></v-spacer>
          <v-col cols="6" style="background-color: #E6E6E6; " class="ml-0 pl-0" justify="center" align="center">
                <v-btn block :color="$store.state.colors.primary" class="text-transform-none" @click="createTheOrder()">
                    <span style="color: white; text-transform: none;" class="RestoRegular">Agregar</span>
                    <v-spacer></v-spacer>
                    <span style="color: white;" class="RestoRegular">
                        ${{ ((parseFloat(this.$store.state.precio_details_footer)*parseFloat(this.$store.state.counter_footer)) + parseFloat(this.$store.state.precio_adicionales_footer)) * parseFloat(counter_footer) }}
                    </span>
                </v-btn>
          </v-col>

          <v-dialog
            v-model="alert"
            max-width="350"
            persistent
            v-if="flag && flag2"
          >
            <v-card>

                <v-card-title class="headline"><span>¡Atención!</span></v-card-title>

                <v-card-text>
                Si agregas más de un elemento se mantendrá la misma configuración. Para hacer una segunda personalización agrega platillos independientes.
                </v-card-text> 

                <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn @click="alert=false; flag=false" :color="$store.state.colors.primary" style="color: white" class="buttonLower">
                    Entendido
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        </v-row>
      </v-col>
    </v-row>
  
</template>

<script>
export default {
    data () {
        return{
            counter_footer: 1,
            final_sum: 15.0,
            alert: false,
            flag: true,
            flag2: true
        };
    },
    mounted(){
      this.$store.state.counter_footerMUC0 = 0;
      // console.log(this.$store.state.maxContValidation)
      // if(this.$store.state.maxContValidation == 0)
      //   this.counter_footer= this.$store.state.counter_footerMUC0;
    },
    methods: {
      createTheOrder(){
        if(this.$store.state.maxContValidation == 0)
          this.$store.state.cantidad_footer = this.$store.state.counter_footerMUC0;
        else
          this.$store.state.cantidad_footer = this.counter_footer;
        this.$root.$emit('createOrder');
      },
      TheAlert(){
        this.flag2 = this.$store.state.modificators_flag;
        this.alert = true;
      }
    }
}

</script>

<style scoped>
    .btn-left:enabled {
        opacity: 1.0;
    }

    .btn-left:disabled {
        opacity: 0.3;
    }

    .btn-right:enabled {
        opacity: 1.0;
    }

    .btn-right:disabled {
        opacity: 0.3;
    }

::-webkit-input-placeholder { /* Edge */
  color: #e6e6e6;
}

:-ms-input-placeholder { /* Internet Explorer */
  color: #e6e6e6;
}

::placeholder {
  color: #e6e6e6;
}

::-webkit-input-placeholder:focus { /* Edge */
  color: #ffffff;
}

:-ms-input-placeholder { /* Internet Explorer */
  color: #ffffff;
}

::placeholder {
  color: #ffffff;
}

input:focus{
    background: rgb(252, 120, 96);
    color: whitesmoke;
}

input{
    color: whitesmoke;
}

.btn-color-border{
    border-color: #39b54a !important;
}
</style>